var render = function render() {
  var _vm$selectedPlan$disc;
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('div', {
    attrs: {
      "id": "confirmation"
    }
  }, [_c('h1', {
    staticClass: "mb-12 light:text-blue-500"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "plan-container pb-6 cs-border",
    class: {
      'border-b': !_vm.isCau
    }
  }, [_c('div', {
    staticClass: "text-xl font-medium mb-3"
  }, [_vm._v(_vm._s(_vm.planHeaderText))]), _vm._v(" "), _c('div', {
    staticClass: "plan",
    class: {
      editable: _vm.allowPlanChange
    },
    on: {
      "click": () => _vm.allowPlanChange && !_vm.submitting && (_vm.showModal = true)
    }
  }, [_c('img', {
    staticClass: "icon self-center",
    attrs: {
      "src": _vm.selectedPlan.icon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-info-container ml-2 flex flex-col flex-grow"
  }, [_c('div', {
    staticClass: "plan-name mb-2 flex-grow font-medium leading-5"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.selectedPlan.mobile && _vm.selectedPlan.mobile.title || _vm.selectedPlan.title) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "plan-price mb-2 font-medium text-lg leading-5"
  }, [_vm.plan.billingCycle <= 0 ? _c('span', [_vm._v("$" + _vm._s(_vm.selectedPlan.price[0]) + "/month")]) : _c('span', [_vm._v("$" + _vm._s(_vm.selectedPlan.price[1]) + "/year")]), _vm._v(" "), _vm.selectedPlan.displayOnlyFullPrice[_vm.plan.billingCycle] ? _c('span', {
    staticClass: "text-sm opacity-50 line-through"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(`$${_vm.selectedPlan.displayOnlyFullPrice[_vm.plan.billingCycle]}/year`) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm$selectedPlan$disc = _vm.selectedPlan.discount) !== null && _vm$selectedPlan$disc !== void 0 && _vm$selectedPlan$disc[_vm.plan.billingCycle] ? _c('span', {
    staticClass: "plan--discount"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.selectedPlan.discount[_vm.plan.billingCycle]) + "% off\n\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "plan-duration color-gray-500 text-sm leading-5 uppercase tracking-wide"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.plan.billingCycle === 1 ? 'Annual' : 'Monthly') + " membership\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm.allowPlanChange ? _c('div', {
    staticClass: "editable--button flex items-center ml-2 mt-4",
    class: {
      disabled: _vm.submitting
    }
  }, [_c('button', {
    staticClass: "button--white"
  }, [_vm._v("Change Plan")])]) : _vm._e()]), _vm._v(" "), _vm.allowPlanChange ? _c('plan-change-modal', {
    attrs: {
      "open": _vm.showModal,
      "plans": _vm.plans,
      "plan": _vm.modalPlan,
      "check-insufficient-funds": _vm.checkInsufficientFunds,
      "balance-check": _vm.balanceCheck
    },
    on: {
      "update:open": function ($event) {
        _vm.showModal = $event;
      },
      "update:plan": function ($event) {
        _vm.modalPlan = $event;
      },
      "update:balanceCheck": function ($event) {
        _vm.balanceCheck = $event;
      },
      "update:balance-check": function ($event) {
        _vm.balanceCheck = $event;
      },
      "relinkPlaid": function ($event) {
        return _vm.$emit('relinkPlaid');
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "details flex flex-col space-y-6",
    class: {
      cardholder: _vm.isCau
    }
  }, [_vm.isCau ? _c('div', {
    staticClass: "mt--6 font-medium text-xl leading-6"
  }, [_vm._v("Details")]) : _vm._e(), _vm._v(" "), _vm.isCau ? _c('div', {
    staticClass: "plan-detail border-b pb-6"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Next payment due")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.formattedProcessDate))])]) : _vm._e(), _vm._v(" "), !_vm.isCau ? _c('div', {
    staticClass: "plan-detail pt-6",
    class: {
      'pb-6': !_vm.scheduledPayment,
      'border-b': !_vm.scheduledPayment
    }
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Pay with")]), _vm._v(" "), _c('div', [_vm._v("Account ending in " + _vm._s(_vm.metadata.account_last_four))])]) : _vm._e(), _vm._v(" "), _vm.allowAutopayChange ? _c('div', {
    staticClass: "plan-schedule"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Membership payment schedule")]), _vm._v(" "), !_vm.isCau ? _c('slide-toggle', {
    attrs: {
      "input-id": "autopay-input",
      "on-label": "Autopay",
      "off-label": "Manual"
    },
    model: {
      value: _vm.selectedAutopay,
      callback: function ($$v) {
        _vm.selectedAutopay = $$v;
      },
      expression: "selectedAutopay"
    }
  }) : _c('div', [_vm._v(_vm._s(_vm.selectedAutopay ? 'Autopay' : 'Manual'))])], 1) : _vm._e(), _vm._v(" "), _vm.isCau ? _c('div', {
    staticClass: "plan-detail pb-6"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("Payment with")]), _vm._v(" "), _c('div', [_vm._v("Account ending in " + _vm._s(_vm.metadata.account_last_four))])]) : _vm._e(), _vm._v(" "), !_vm.isCau ? _c('div', {
    staticClass: "plan-detail"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.scheduledPayment ? 'Payment' : 'First payment') + " date\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.formattedProcessDate))])]) : _vm._e(), _vm._v(" "), !_vm.isCau && (!_vm.scheduledPayment || _vm.selectedAutopay) ? _c('div', {
    staticClass: "plan-detail"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_vm._v("\n\t\t\t\t\t\t\tNext payment " + _vm._s(_vm.scheduledPayment ? 'scheduled' : 'due') + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.formattedNextPaymentDate))])]) : _vm._e()]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "mt-10 space-y-5 policies"
  }, [_vm.showChaPolicy ? _c('div', {
    staticClass: "flex flex-row items-start space-x-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.policyCheckboxes,
      expression: "policyCheckboxes"
    }],
    attrs: {
      "id": "cardholder_standing_ach-input",
      "value": "cardholder_agreement",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.policyCheckboxes) ? _vm._i(_vm.policyCheckboxes, "cardholder_agreement") > -1 : _vm.policyCheckboxes
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.policyCheckboxes,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "cardholder_agreement",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.policyCheckboxes = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.policyCheckboxes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.policyCheckboxes = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cs-disclosure-text leading-5",
    attrs: {
      "for": "cardholder_standing_ach-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tI agree to my\n\t\t\t\t\t\t\t\t"), !_vm.usePatriot ? _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Cardholder_Agreement')).apply(null, arguments);
      }
    }
  }, [_vm._v("Evolve Bank's Debit Cardholder Agreement\n\t\t\t\t\t\t\t\t")]) : _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Patriot_Cardholder_Agreement')).apply(null, arguments);
      }
    }
  }, [_vm._v("Patriot Bank's Debit Cardholder Agreement\n\t\t\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t\t\tand\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Standing_ACH_Authorization')).apply(null, arguments);
      }
    }
  }, [_vm._v("Standing ACH Authorization")])])]) : _vm._e(), _vm._v(" "), _vm.showAchPolicy && _vm.selectedAutopay ? _c('div', {
    staticClass: "flex flex-row items-start space-x-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.policyCheckboxes,
      expression: "policyCheckboxes"
    }],
    key: "recurring_ach_notice-input",
    attrs: {
      "id": "recurring_ach_notice-input",
      "value": "recurring_ach_authorization",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.policyCheckboxes) ? _vm._i(_vm.policyCheckboxes, "recurring_ach_authorization") > -1 : _vm.policyCheckboxes
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.policyCheckboxes,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "recurring_ach_authorization",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.policyCheckboxes = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.policyCheckboxes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.policyCheckboxes = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cs-disclosure-text leading-5",
    attrs: {
      "for": "recurring_ach_notice-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tI agree to my\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'Recurring_ACH_Authorization')).apply(null, arguments);
      }
    }
  }, [_vm._v("Recurring Membership ACH Authorization")])])]) : _vm.showAchPolicy ? _c('div', {
    staticClass: "flex flex-row items-start space-x-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.policyCheckboxes,
      expression: "policyCheckboxes"
    }],
    key: "one_time_ach_authorization-input",
    attrs: {
      "id": "one_time_ach_authorization-input",
      "value": "one_time_ach_authorization",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.policyCheckboxes) ? _vm._i(_vm.policyCheckboxes, "one_time_ach_authorization") > -1 : _vm.policyCheckboxes
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.policyCheckboxes,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "one_time_ach_authorization",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.policyCheckboxes = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.policyCheckboxes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.policyCheckboxes = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cs-disclosure-text leading-5",
    attrs: {
      "for": "one_time_ach_authorization-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tI authorize Extra to initiate a\n\t\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.$emit('showThisDisclosure', 'One_Time_ACH_Authorization')).apply(null, arguments);
      }
    }
  }, [_vm._v("One-Time ACH Authorization")]), _vm._v("\n\t\t\t\t\t\t\t\tto my bank account\n\t\t\t\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), _vm.isCau ? _c('p', {
    staticClass: "mt-8 text-base leading-5 cs-disclosure-text"
  }, [_vm._v("\n\t\t\t\t\t\tBy clicking “" + _vm._s(_vm.continueButtonText) + "”, I am confirming my membership plan and billing\n\t\t\t\t\t\tcycle as defined above.\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.newCardholder ? _c('p', {
    staticClass: "mt-8 text-sm leading-5 cs-disclosure-text"
  }, [_vm._v("\n\t\t\t\t\t\tYou will be charged for your Extra membership immediately upon approval. Identity\n\t\t\t\t\t\tdocuments may be required prior to approval or card activation.\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button--filled sm:w-full",
    class: _vm.continueButtonClasses,
    attrs: {
      "disabled": !_vm.readyToSubmit,
      "type": "submit",
      "name": "confirm-plan"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.trySubmit.apply(null, arguments);
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.continueButtonText) + "\n\t\t\t\t\t")])])]), _vm._v(" "), _c('small', {
    staticClass: "my-4 mt-16 text-sm leading-5 cs-documents-text"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.scheduledPayment ? 'You can view account documents at any time in the free Extra app' : 'You can view a copy of your account documents and agreements at any time in the free Extra app') + "\n\t\t\t")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };